zpr-showcase-preview-modal {
  zpr-modal > .wrapper > header {
    padding-bottom: 32px;
  }
  .next-btn {
    svg {
        transform: rotate(180deg);
    }
  }
  iframe {
    width: 100%;
    border-radius: 8px;
  }

  [slot="footer"] {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    .prev-btn {
      grid-column: 1 / span 1;
      justify-self: start;
    }
    .cta-btn {
      grid-column: 2 / span 1;
    }
    .next-btn {
      grid-column: 3 / span 1;
      justify-self: end;
    }
  }

  zpr-modal > .wrapper > footer .btn+.btn {
    &.cta-btn {
      margin-left: 0;
    }
  }

  @media (max-width: $breakpoint-xs-max) {
    [slot="footer"] {
      grid-row-gap: 12px;
      .cta-btn {
        grid-column: 1/4;
        grid-row: 1;
      }
    }
  }

  [slot="cta-body"] {
    display: none;
  }
  &.is-cta-visible {
    [slot="cta-body"] {
      display: block;
    }
    .modal-body {
      display: none;
    }

    &.cta-charcoal {
      .wrapper {
        background-color: color('charcoal');
      }
      [slot="header"],
      [slot="cta-body"] p {
        text-align: center;
        color: white;
      }
      .btn.btn-ghost, svg {
        fill: white;
        color: white;
        &:hover {
          color: color('ocean');
        }
      }
    }
  }
}
